import { useFormik } from "formik";
import { useEffect, useMemo, useRef, useState } from "react";
import PhoneInput, {
  isPossiblePhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useGoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { GoogleIcon } from "../../../../assets/images";
import closeye from "../../../../assets/images/closeye.png";
import eye from "../../../../assets/images/eye.png";
import rightLogo from "../../../../assets/images/logo.png";
import basin_logo from "../../../../assets/images/basin_logo.png";
import MainLoader from "../../../../components/mainLoader";
import VerifyOtpModal from "../../../../components/modals/Verifition.tsx";
import { STRINGS } from "../../../../constants/strings";
import useAuth from "../../../../lib/hooks/useAuth";
import { DEVICE_TYPE, LOGIN } from "../../../../utils/constants";
import { APP_ROUTES } from "../../../../utils/routes";
import { verifyOtp } from "../../signup/api";
import { fetchGoogleUserInfo, generateToken, login, socialLogin } from "../api";
import { Location } from "../interface";
import styles from "../styles/login.module.css";
import { loginEmailSchema, loginPasswordSchema } from "../validations";
import LoginLeft from "./LoginLeft";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [passwordShow, setPasswordShow] = useState<boolean>(false);
  const [loginContinuous, setLoginContinuous] = useState<boolean>(false);
  const [loginIdentifier, setIoginIdentifier] = useState<any>("");
  const [otpId, setOtpId] = useState<any>("");
  const [show, setShow] = useState("");
  const [timer, setTimer] = useState(0);
  const current_url: any = window.localStorage.getItem("current_url");

  const handleSuccess = async (credentialResponse: any) => {
    try {
      setLoader(true);
      const userInfo: any = await fetchGoogleUserInfo(
        credentialResponse?.access_token
      );

      toast.promise(
        socialLogin({
          socialId: userInfo?.sub,
          email: userInfo?.email,
          deviceType: DEVICE_TYPE.WEB,
          loginType: 2,
        }),
        {
          pending: {
            render() {
              return "Trying to login user";
            },
          },
          success: {
            render({ data }) {
              setLoader(false);
              // if (current_url) navigate(current_url)
              window.history.back();
              loginUser(data.data.accessToken);
              return "Login Successful";
            },
          },
          error: {
            render({ data }: any) {
              setLoader(false);
              return data.data.message;
            },
          },
        }
      );
    } catch (err) {}
  };

  const googleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      handleSuccess(tokenResponse);
    },
  });

  const { isAuthenticated, loginUser } = useAuth();
  const phoneNumberRef = useRef<any>(null);
  const [isPhoneNumber, setPhoneNumberInput] = useState<boolean>(false);
  const [geoLocations, setGeoLocations] = useState<Location | null>(null);
  const [loader, setLoader] = useState<boolean>(false);
  const [submitButtonValue, setSubmitButtonValue] = useState<number>(2);
  const [fieldForVerify, setFieldForVerify] = useState("");

  useEffect(() => {
    if (
      isPhoneNumber &&
      phoneNumberRef &&
      phoneNumberRef.current &&
      phoneNumberRef.current.focus
    ) {
      phoneNumberRef.current.focus();
    }
  }, [isPhoneNumber]);

  const formik = useFormik({
    initialValues: {
      loginIdentifier: "",
      password: "",
      deviceType: DEVICE_TYPE.WEB,
      countryIsoCode: "IN",
      loginVia: 0,
      countryCode: "",
    },
    validationSchema: useMemo(() => {
      if (!loginContinuous) return loginEmailSchema;
      if (submitButtonValue == 2) return loginPasswordSchema;
    }, [loginContinuous, submitButtonValue]),

    onSubmit: async (values) => {
      const loginPayload: any = {
        deviceType: DEVICE_TYPE.WEB,
      };

      if (!loginContinuous) {
        if (!isPhoneNumber) {
          const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
          if (!emailRegex.test(values.loginIdentifier)) {
            formik.setFieldError("loginIdentifier", "Invalid Email");
            return;
          }
          setLoginContinuous(true);
          setIoginIdentifier(values.loginIdentifier);
        } else {
          if (
            values.loginIdentifier.length < 10 ||
            values.loginIdentifier.length > 13
          ) {
            formik.setFieldError(
              "loginIdentifier",
              "Please enter valid phone number!"
            );
            return;
          }
          setIoginIdentifier(values.loginIdentifier);
          setLoginContinuous(true);
        }
        return;
      }

      if (isPossiblePhoneNumber(loginIdentifier)) {
        const parsedNumber = parsePhoneNumber(loginIdentifier);
        loginPayload.phoneNumber = parsedNumber?.nationalNumber as string;
        loginPayload.countryCode = ("+" +
          parsedNumber?.countryCallingCode) as string;
      } else {
        loginPayload.email = loginIdentifier;
      }

      if (submitButtonValue == LOGIN.NORMALPASS) {
        setLoader(true);
        setOtpId("");
        loginPayload.loginVia = LOGIN.NORMALPASS;
        loginPayload.password = values.password;
        toast.promise(login(loginPayload), {
          pending: {
            render() {
              return "Trying to login user";
            },
          },
          success: {
            render({ data }) {
              setLoader(false);
              // if (current_url) navigate(current_url)
              // window.history.back();
              loginUser(data.data.accessToken);
              navigate("/");
              return "Login Successful";
            },
          },
          error: {
            render({ data }: any) {
              setLoader(false);
              return data?.data?.message;
            },
          },
        });
        return;
      }

      loginPayload.loginVia = LOGIN.OTPPASS;
      toast.promise(login(loginPayload), {
        pending: {
          render() {
            return "Trying to login user";
          },
        },
        success: {
          render({ data }) {
            setLoader(false);
            setOtpId(data.data.otpId);
            setShow("show");
            setTimer(Date.now() + 30000);
            return "OTP sent Successful";
          },
        },
        error: {
          render({ data }: any) {
            setLoader(false);
            return data.data.message;
          },
        },
      });
    },
  });

  useEffect(() => {
    if (!formik.values.loginIdentifier) {
      setPhoneNumberInput(false);
    }
  }, [formik.values.loginIdentifier]);

  if (isAuthenticated) {
    return <Navigate to={APP_ROUTES.HOME} />;
  }

  const toggleOldPasswordVisibility = () => {
    setPasswordShow(passwordShow ? false : true);
  };

  const otpVeriFy = (payload: any) => {
    setLoader(true);
    toast.promise(verifyOtp(payload), {
      pending: {
        render() {
          return "Trying to sent otp";
        },
      },
      success: {
        render({ data }: any) {
          setLoader(false);
          generateToken({
            userId: data?.data?._id,
            deviceType: DEVICE_TYPE.WEB,
          })
            .then((res) => {
              // if (current_url) navigate(current_url)
              window.history.back();
              loginUser(res.data.accessToken);
              setShow("");
            })
            .catch((error) => {
              console.log(error);
              setShow("");
              setLoader(false);
            });
          return 'return "Login Successful';
        },
      },
      error: {
        render({ data }: any) {
          setLoader(false);
          return data.data.message;
        },
      },
    });
  };

  const handleResendOTP = () => {
    setShow("");
    formik.submitForm();
  };
  const ClosedModal = (newValue: any) => {
    setShow(newValue);
  };

  return (
    <div className={styles.loginPage}>
      {loader && <MainLoader />}
      <div className="row m-0">
        <LoginLeft />
        <div className="col-md-6 p-0">
          <div className={styles.loginrelate}>
            <div className={styles.loginRight}>
              <div className={styles.topLogin}>
                <div className="row">
                  <div className="col-md-6">
                    {/* <p>Already have an account? <Link to="/signup"> Signup</Link></p> */}
                  </div>
                  <div className="col-md-6">
                    <span>
                      <Link to="/contact">{STRINGS.NEED_HELP}</Link>
                    </span>
                  </div>
                </div>
              </div>
              <Link to="/">
                <img src={basin_logo} alt="" width={300} />
              </Link>
              <h4 className="my-3">{STRINGS.SIGNIN_HEADING}</h4>
              <form
                onSubmit={(e: any) => {
                  e.preventDefault();
                  setSubmitButtonValue(e.nativeEvent.submitter.value);

                  setTimeout(() => {
                    formik.handleSubmit(e);
                  }, 0);
                }}
              >
                {!loginContinuous ? (
                  <>
                    <div className={styles["form-group"]}>
                      <label className="d-flex align-items-center">
                        {STRINGS.EMAIL_OR_PHONE_LABEL}
                      </label>
                      {isPhoneNumber ? (
                        <PhoneInput
                          placeholder={STRINGS.ENTER_PHONE_NUMBER}
                          onChange={(value) =>
                            formik.setFieldValue("loginIdentifier", value)
                          }
                          value={formik.values.loginIdentifier}
                          ref={phoneNumberRef}
                          className={styles.phoneNumber}
                        />
                      ) : (
                        <input
                          type="text"
                          name="loginIdentifier"
                          placeholder={STRINGS.EMAIL_OR_PHONE_PLACEHOLDER}
                          onChange={(event) => {
                            const {
                              target: { value },
                            } = event;
                            const numberRegex = /^[0-9]+$/;

                            if (numberRegex.test(value))
                              setPhoneNumberInput(true);
                            formik.setFieldValue("loginIdentifier", value);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.loginIdentifier}
                        />
                      )}

                      {formik.touched.loginIdentifier &&
                        formik.errors.loginIdentifier && (
                          <div className={styles.error}>
                            {formik.errors.loginIdentifier}
                          </div>
                        )}
                    </div>

                    <div className={styles["form-group"]}>
                      <button
                        type="submit"
                        value="2"
                        className={styles["login-submit"]}
                      >
                        {STRINGS.NEXT_BUTTON}
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={styles["form-group"]}>
                      <label className="d-flex align-items-center">
                        {STRINGS.PASSWORD_LABEL_LOGIN}
                      </label>
                      <input
                        type={passwordShow ? "text" : "password"}
                        name="password"
                        placeholder={STRINGS.PASSWORD_PLACEHOLDER_LOGIN}
                        onChange={(e) => {
                          setSubmitButtonValue(2);
                          formik.setFieldValue("password", e.target.value);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault(); // Prevent default form submission
                            setSubmitButtonValue(2);
                            setTimeout(() => {
                              formik.handleSubmit();
                            }, 0);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.password}
                      />
                      <span onClick={toggleOldPasswordVisibility}>
                        {passwordShow ? (
                          <img src={eye} alt="" />
                        ) : (
                          <img src={closeye} alt="" />
                        )}
                      </span>
                      {formik.touched.password && formik.errors.password && (
                        <div className={styles.error}>
                          {formik.errors.password}
                        </div>
                      )}
                    </div>
                    <div className={styles["form-group"]}>
                      <div className={styles.forgot}>
                        <a href={APP_ROUTES.FORGET_PASSWORD}>
                          {STRINGS.FORGOT_PASSWORD_LINK}
                        </a>
                        <button type="submit" value="1" className={styles.otp}>
                          {STRINGS.LOGIN_WITH_OTP_BUTTON}
                        </button>
                      </div>
                    </div>

                    <div className={styles["form-group"]}>
                      <button
                        type="submit"
                        value="2"
                        className={styles["login-submit"]}
                      >
                        {STRINGS.LOGIN_BUTTON}
                      </button>
                    </div>
                  </>
                )}
                <div className={styles.ExtraSign}>
                  <div className="col-md-12">
                    <p>
                      {STRINGS.DONT_HAVE_ACCOUNT}{" "}
                      <Link to="/signup"> {STRINGS.SIGNUP_LINK}</Link>
                    </p>
                  </div>
                </div>
                <div className={styles.login}>
                  <span>{STRINGS.CONTINUE_WITH}</span>
                  <hr />
                </div>
                <div className={styles.social}>
                  <ul>
                    <li onClick={() => googleLogin()}>
                      <a href="#">
                        <img src={GoogleIcon} alt="" />
                        {STRINGS.GOOGLE_LOGIN}
                      </a>
                    </li>
                    {/* <li>
                      <a href="#">
                        <img src={AppleIcon} alt="" />
                        Apple
                      </a>
                    </li> */}
                  </ul>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {show && (
        <VerifyOtpModal
          show={show}
          otpId={otpId}
          timer={timer}
          otpVeriFy={otpVeriFy}
          fieldForVerify={fieldForVerify}
          handleResendOTP={handleResendOTP}
          ClosedModal={ClosedModal}
        />
      )}
    </div>
  );
};

export default Login;
